var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "home-header-hero", attrs: { "data-nosnippet": "" } },
    [
      _c(
        "div",
        { staticClass: "home-header-hero-carousel slick" },
        _vm._l(_vm.heros, function(hero) {
          return _c(
            "div",
            {
              staticClass: "carousel-item",
              style: {
                backgroundImage: "url(" + _vm.teaserImage(hero["acf"]) + ")"
              }
            },
            [
              _c("div", { staticClass: "overlay" }),
              _vm._v(" "),
              _c("div", { staticClass: "carousel-caption" }, [
                _c("h2", {
                  staticClass: "heading",
                  class: {
                    "heading-black":
                      hero["acf"]["teaser_headline_color"] === "black",
                    "heading-pink":
                      hero["acf"]["teaser_headline_color"] === "red",
                    "heading-white":
                      hero["acf"]["teaser_headline_color"] === "white",
                    "heading-none":
                      hero["acf"]["teaser_headline_color"] === "none"
                  },
                  domProps: { innerHTML: _vm._s(hero["acf"]["teaser_title"]) }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "action" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/" + hero["post_name"] } },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-pink-white ani-btn-hover-scale-bounce"
                          },
                          [_vm._v("mehr erfahren")]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67c65da1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c65da1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/HomeHeaderHero.vue
// module id = 617
// module chunks = 0